import { render } from "./ScopeItemRow.vue?vue&type=template&id=0a8cda54"
import script from "./ScopeItemRow.vue?vue&type=script&lang=js"
export * from "./ScopeItemRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__